import Animation from './Animation';
import { play } from '../../../SoundManager';

export default class Brew extends Animation {

	constructor (master) {

		super(master, 0);
		this.loadAudio("brew");
	}

	run () {

	}
}